
import createIconComponent from './utils/createIconComponent';
import React from 'react';
var IconArrowLeftAlt = createIconComponent({ fillContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M4.5 12a2.3 2.3 0 0 1 .78-1.729L16.432.46a1.847 1.847 0 0 1 2.439 2.773l-9.752 8.579a.25.25 0 0 0 0 .376l9.752 8.579a1.847 1.847 0 1 1-2.439 2.773L5.284 13.732A2.31 2.31 0 0 1 4.5 12z' })
  ), lightContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M18.401 24a.497.497 0 0 1-.331-.125L5.495 12.748a1.002 1.002 0 0 1-.001-1.496L18.069.125a.502.502 0 0 1 .707.044.5.5 0 0 1-.043.705L6.157 12l12.575 11.125a.501.501 0 0 1-.331.875z' })
  ), regularContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M16.25 24a.743.743 0 0 1-.53-.22L5 13.06a1.488 1.488 0 0 1-.439-1.059c0-.4.155-.777.438-1.06L15.72.22c.141-.142.33-.22.53-.22s.389.078.53.22c.142.141.22.33.22.53s-.078.389-.22.53L6.06 12l10.72 10.72a.744.744 0 0 1 0 1.06.749.749 0 0 1-.53.22z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconArrowLeftAlt.displayName = 'IconArrowLeftAlt';
export default IconArrowLeftAlt;